import React from 'react';

// Card "Visão Geral": header (com o seletor de período à direita) + KPIs + barras.
const DashboardHero = ({
  faturamento, despesas, resultado, os, ticket, loading, brl, num, colors, subtexts = {}, periodSelector,
}) => {
  const isLucro = resultado >= 0;
  const max = Math.max(faturamento, despesas, Math.abs(resultado), 1);

  const kpis = [
    { key: 'faturamento', label: 'Faturamento total', value: brl(faturamento), cls: 'positive' },
    { key: 'despesas', label: 'Despesas', value: brl(despesas), cls: 'negative' },
    { key: 'resultado', label: 'Resultado', value: brl(resultado), cls: isLucro ? 'positive' : 'negative', highlight: true },
    { key: 'os', label: 'OS geradas', value: num(os), cls: '' },
    { key: 'ticket', label: 'Ticket médio', value: brl(ticket), cls: '' },
  ];

  const bars = [
    { label: 'Faturamento', v: faturamento, color: colors.blue },
    { label: 'Despesas', v: despesas, color: colors.red },
    { label: 'Resultado', v: resultado, color: colors.green },
  ];

  return (
    <section className="dg-card dg-overview">
      <div className="dg-section-title">
        <span className="dg-dot" style={{ background: colors.green }} />
        <span>Visão Geral</span>
        <div className="dg-section-title-right">{periodSelector}</div>
      </div>

      <div className="dg-overview-top">
        {kpis.map((k) => {
          const sub = subtexts[k.key];
          return (
            <div className={`dg-overview-item${k.highlight ? ' highlight' : ''}`} key={k.key}>
              <div className="dg-metric-label">{k.label}</div>
              <div className={`dg-metric-value ${k.cls}`}>{loading ? '—' : k.value}</div>
              {!loading && sub && sub.text && (
                <div className={`dg-metric-note ${sub.tone}`}>{sub.text}</div>
              )}
            </div>
          );
        })}
      </div>

      <div className="dg-comparison-bars">
        {bars.map((b) => (
          <div className="dg-comparison-row" key={b.label}>
            <div className="dg-comparison-label">
              <span className="dg-comparison-dot" style={{ background: b.color }} />
              {b.label}
            </div>
            <div className="dg-bar-track">
              <div className="dg-bar" style={{ width: `${(Math.abs(b.v) / max) * 100}%`, background: b.color }} />
            </div>
            <div className="dg-comparison-value">{brl(b.v)}</div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default DashboardHero;
